module.exports = __webpack_public_path__ + "static/media/icono_incompleto.cc399b9c.svg";